import { Component, OnInit } from '@angular/core';
import { ArticleService } from '../services/article.service';
interface Person {
  key: string;
  name: string;
  priority: string;
}
@Component({
  selector: 'app-salary',
  templateUrl: './salary.component.html',
  styleUrls: ['./salary.component.less']
})
export class SalaryComponent implements OnInit {
  perPage = 10;
  page = 1;
  total:string;
  payslipData: any;
  isCollapsed = false;
  isVisible:any;
  constructor(
    private articleService: ArticleService,
  ) { }

  getPayslip(){
    this.articleService.getPayslip(this.perPage, this.page).subscribe((res)=>{
      this.payslipData = res.data.docs;
      this.total = res.data.total;
    })
  }

  showModal(id:string): void {
    this.isVisible = id;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  onPageIndexChange($event) {
    this.articleService.getPayslip(this.perPage, $event).subscribe((res:any)=>{
      this.payslipData = res.data.docs;
      this.total = res.data.total;
    })
    
  }

  ngOnInit() {
    this.getPayslip();
  }

}
